export class PlansDto {
  static fromApi(plans) {
    return plans.map((plan) => ({
      id: plan.id,
      tier: plan.tier,
      isFree: plan.isFree,
      isDynamic: plan.isDynamic,
      nameGr: plan.nameGr,
      nameEn: plan.nameEn,
      descriptionGr: plan.descriptionGr,
      descriptionEn: plan.descriptionEn,
      // A dynamic plan has no price of its own — it's the farmer's bracket price.
      price: plan.isDynamic ? plan.yourPrice : plan.price,
      brackets: plan.brackets,
      yourBracketId: plan.yourBracketId,
      stremmata: plan.yourStremmata,
      features: plan.features,
    }));
  }
}
